module.exports = __webpack_public_path__ + "static/heroDesktop@x1-619be3a48d56c2b541b232c664b363f6.png";